import { Address } from "wagmi";
import { getSupportedChain } from "../helpers/getSupportedChain";

export enum OrderStatus {
  "NOT_PROCESSED",
  "IN_PROGRESS",
  "PAYED_BACK",
  "CANCELED",
  "LIQUIDATED",
}

export enum OrderKind {
  "OFFER",
  "LIST",
}
export enum TokenKind {
  "ERC721",
  "ERC1155",
}

const development: IAssetToBorrow[] = [
  {
    address: "0xe2b0ba1511052a11dfb7586273a9f73c2227be6b",
    value: "WBNB",
    name: "WBNB",
  },
];

const staging: IAssetToBorrow[] = [
  {
    address: "0xe2b0ba1511052a11dfb7586273a9f73c2227be6b",
    value: "WBNB",
    name: "WBNB",
  },
];

const production: IAssetToBorrow[] = [
  {
    address: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
    value: "WBNB",
    name: "WBNB",
  },
];

const assetsToBorrowArr = { development, staging, production };

export const ASSETS_TO_BORROW = assetsToBorrowArr[process.env.NEXT_PUBLIC_ENV_VARIABLE];

export const LENDING_CONTRACT_ADDRESS: Address = "0x7CDEe851050EbD22Dd7dDb6dfc97c73C5c36238f";

export const CREATE_BORROW_EIP712_DOMAIN = {
  name: "Bit5 Lending",
  version: "1",
  chainId: 56,
  verifyingContract: LENDING_CONTRACT_ADDRESS,
};

export const CREATE_DYNAMIC_BORROW_EIP712_DOMAIN = (chainId: string): any => ({
  name: "Bit5 Lending",
  version: "1",
  chainId: parseInt(chainId),
  verifyingContract: getSupportedChain(chainId)?.lendingContract,
});

export const CREATE_BORROW_EIP712_TYPES = {
  EIP712Domain: [
    { name: "name", type: "string" },
    { name: "version", type: "string" },
    { name: "chainId", type: "uint256" },
    { name: "verifyingContract", type: "address" },
  ],
  Times: [
    { name: "signingTime", type: "uint256" },
    { name: "expiration", type: "uint256" },
    { name: "duration", type: "uint256" },
  ],
  Order: [
    { name: "issuer", type: "address" },
    { name: "nftAddresses", type: "address[]" },
    { name: "colleteralTokenIDs", type: "uint256[]" },
    { name: "amounts", type: "uint256[]" },
    { name: "paymentToken", type: "address" },
    { name: "borrowAmount", type: "uint256" },
    { name: "interestRate", type: "uint256" },
    { name: "times", type: "Times" },
    { name: "orderKind", type: "uint256" },
    { name: "tokenKinds", type: "uint256[]" },
    { name: "isGlobal", type: "bool" },
  ],
  AcceptTerms: [{ name: "M", type: "string" }],
};

export const CREATE_BORROW_EIP712_TYPES_ORDER = {
  Times: [
    { name: "signingTime", type: "uint256" },
    { name: "expiration", type: "uint256" },
    { name: "duration", type: "uint256" },
  ],
  Order: [
    { name: "issuer", type: "address" },
    { name: "nftAddresses", type: "address[]" },
    { name: "colleteralTokenIDs", type: "uint256[]" },
    { name: "amounts", type: "uint256[]" },
    { name: "paymentToken", type: "address" },
    { name: "borrowAmount", type: "uint256" },
    { name: "interestRate", type: "uint256" },
    { name: "times", type: "Times" },
    { name: "orderKind", type: "uint256" },
    { name: "tokenKinds", type: "uint256[]" },
    { name: "isGlobal", type: "bool" },
  ],
};

export const acceptTermsMessage = `Welcome to Bit5!  Click to sign in and accept the Bit5 Terms of Service (https://docs.bit5.com/legal/terms-of-service) and Privacy Policy (https://docs.bit5.com/legal/privacy-policy).This request will not trigger a blockchain transaction or cost any gas fees.`;
